import { c as _c } from "react/compiler-runtime";
/* eslint-disable @typescript-eslint/no-explicit-any */
import { ChevronRight, Truck } from "lucide-react";
import Link from "next/link";
import React from "react";
import Label from "./label";
import { DietaryCategory } from "@/types/product";
import Counter from "./Counter";
import VoucherCarousel from "@/components/product/details/ProductDetailView/sections/VoucherCarousel";
interface Baker {
  _id: string;
  name: string;
  link: string;
}
interface ProductCustomizationHeaderProps {
  baker: Baker;
  title: string;
  price: string;
  labels: DietaryCategory[];
  vendorId: string | number | null;
  prepTimeHours?: number;
  formData: any;
  onIncrement: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onDecrement: (e: React.MouseEvent<HTMLButtonElement>) => void;
  shippingState?: string;
  freeShippingThreshold?: number;
  product?: any;
}
const ProductCustomizationHeader: React.FC<ProductCustomizationHeaderProps> = t0 => {
  const $ = _c(34);
  const {
    baker,
    title,
    price,
    labels,
    formData,
    onIncrement,
    onDecrement,
    shippingState,
    freeShippingThreshold,
    product
  } = t0;
  const shortDescription = product?.metadata?.short_description || product?.short_description;
  let t1;
  if ($[0] !== baker.name) {
    t1 = <span className="truncate">{baker.name}</span>;
    $[0] = baker.name;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ChevronRight className="ml-2 h-4 w-4 flex-shrink-0" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== baker.link || $[4] !== t1) {
    t3 = <div className="flex flex-row items-center w-full"><Link href={baker.link} className="inline-flex lg:max-w-[520px] max-w-[340px] items-center rounded-full bg-[#037A6A]/5 px-4 py-1.5 text-xs font-medium uppercase tracking-widest text-[#037A6A] transition-colors hover:bg-[#037A6A]/10 lg:text-lg">{t1}{t2}</Link></div>;
    $[3] = baker.link;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== title) {
    t4 = <div className="flex flex-row items-center justify-start space-x-3 w-full mt-2"><h1 className="lg:text-4xl text-xl font-lora font-medium text-gray-700 leading-tight tracking-tight drop-shadow-sm">{title}</h1></div>;
    $[6] = title;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = parseFloat(price);
  let t6;
  if ($[8] !== t5) {
    t6 = t5.toString();
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t6) {
    t7 = <div className="lg:text-4xl text-3xl lg:font-medium font-normal text-[#037A6A] w-full font-outfit tracking-tight ">₹{t6}</div>;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== labels) {
    t8 = labels && labels.length > 0 && <div className="flex mt-4 flex-row items-center justify-start w-full space-x-3 font-outfit max-lg:my-1 ">{labels.map(_temp)}</div>;
    $[12] = labels;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== shortDescription) {
    t9 = shortDescription && <p className="w-full font-outfit text-xs font-light lg:text-sm text-[#5A5A5A] !my-8 leading-relaxed italic max-lg:bg-[#037A6A]/5 py-4 rounded-lg max-lg:px-3 text-left">{shortDescription}</p>;
    $[14] = shortDescription;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== product) {
    t10 = <VoucherCarousel product={product} />;
    $[16] = product;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== freeShippingThreshold || $[19] !== shippingState) {
    t11 = (shippingState || freeShippingThreshold) && <div className="hidden md:flex flex-wrap gap-3 w-full font-outfit text-stone-600">{shippingState && <div className="flex items-center md:space-x-2 space-x-1 bg-v2-surface-container-low md:px-3 px-1.5 py-1.5 rounded-lg border border-v2-outline-variant/30"><Truck className="opacity-70 w-3 h-3 md:w-4 md:h-4 text-[#037A6A]" /><span className="md:text-sm text-xs font-medium ">Ships from {shippingState}</span></div>}{freeShippingThreshold && freeShippingThreshold > 0 && <div className="flex items-center md:space-x-2 space-x-1 bg-v2-surface-container-low md:px-3 px-1.5 py-1.5 rounded-lg border border-v2-outline-variant/30"><Truck className="opacity-70 w-3 h-3 md:w-4 md:h-4 text-[#037A6A]" /><span className="md:text-sm text-xs font-medium ">Free shipping above ₹{parseFloat(freeShippingThreshold.toString()).toString()}</span></div>}</div>;
    $[18] = freeShippingThreshold;
    $[19] = shippingState;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== formData.count || $[22] !== onDecrement || $[23] !== onIncrement) {
    t12 = <div className="w-full flex flex-row items-start md:hidden"><div className="w-auto"><Counter count={formData.count} maxCount={10} onIncrement={onIncrement} onDecrement={onDecrement} strokeWidth={3} countClassNames="font-extrabold text-base" classNames="w-full justify-between py-1.5 px-4 rounded-lg" buttonClassNames="max-sm:w-8 max-sm:h-8 text-[#037A6A] flex items-center justify-center transition-all" /></div></div>;
    $[21] = formData.count;
    $[22] = onDecrement;
    $[23] = onIncrement;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t10 || $[26] !== t11 || $[27] !== t12 || $[28] !== t3 || $[29] !== t4 || $[30] !== t7 || $[31] !== t8 || $[32] !== t9) {
    t13 = <div className="flex flex-col items-center justify-start lg:space-y-6 space-y-3 w-full font-outfit pb-8 max-lg:pb-2">{t3}{t4}{t7}{t8}{t9}{t10}{t11}{t12}</div>;
    $[25] = t10;
    $[26] = t11;
    $[27] = t12;
    $[28] = t3;
    $[29] = t4;
    $[30] = t7;
    $[31] = t8;
    $[32] = t9;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  return t13;
};
export default ProductCustomizationHeader;
function _temp(item, index) {
  return <Label key={index} text={item.name} />;
}